export const HOME_LOGIN_BEGIN = 'HOME_LOGIN_BEGIN';
export const HOME_LOGIN_SUCCESS = 'HOME_LOGIN_SUCCESS';
export const HOME_LOGIN_FAILURE = 'HOME_LOGIN_FAILURE';
export const HOME_LOGIN_DISMISS_ERROR = 'HOME_LOGIN_DISMISS_ERROR';
export const HOME_FETCH_STATISTICS_BEGIN = 'HOME_FETCH_STATISTICS_BEGIN';
export const HOME_FETCH_STATISTICS_SUCCESS = 'HOME_FETCH_STATISTICS_SUCCESS';
export const HOME_FETCH_STATISTICS_FAILURE = 'HOME_FETCH_STATISTICS_FAILURE';
export const HOME_FETCH_STATISTICS_DISMISS_ERROR = 'HOME_FETCH_STATISTICS_DISMISS_ERROR';
export const HOME_FETCH_LOGIN_STATISTICS_BEGIN = 'HOME_FETCH_LOGIN_STATISTICS_BEGIN';
export const HOME_FETCH_LOGIN_STATISTICS_SUCCESS = 'HOME_FETCH_LOGIN_STATISTICS_SUCCESS';
export const HOME_FETCH_LOGIN_STATISTICS_FAILURE = 'HOME_FETCH_LOGIN_STATISTICS_FAILURE';
export const HOME_FETCH_LOGIN_STATISTICS_DISMISS_ERROR = 'HOME_FETCH_LOGIN_STATISTICS_DISMISS_ERROR';
export const HOME_FETCH_LICENSES_BEGIN = 'HOME_FETCH_LICENSES_BEGIN';
export const HOME_FETCH_LICENSES_SUCCESS = 'HOME_FETCH_LICENSES_SUCCESS';
export const HOME_FETCH_LICENSES_FAILURE = 'HOME_FETCH_LICENSES_FAILURE';
export const HOME_FETCH_LICENSES_DISMISS_ERROR = 'HOME_FETCH_LICENSES_DISMISS_ERROR';
export const HOME_GET_PRODUCTS_BEGIN = 'HOME_GET_PRODUCTS_BEGIN';
export const HOME_GET_PRODUCTS_SUCCESS = 'HOME_GET_PRODUCTS_SUCCESS';
export const HOME_GET_PRODUCTS_FAILURE = 'HOME_GET_PRODUCTS_FAILURE';
export const HOME_GET_PRODUCTS_DISMISS_ERROR = 'HOME_GET_PRODUCTS_DISMISS_ERROR';
export const HOME_GET_CUSTOMERS_BEGIN = 'HOME_GET_CUSTOMERS_BEGIN';
export const HOME_GET_CUSTOMERS_SUCCESS = 'HOME_GET_CUSTOMERS_SUCCESS';
export const HOME_GET_CUSTOMERS_FAILURE = 'HOME_GET_CUSTOMERS_FAILURE';
export const HOME_GET_CUSTOMERS_DISMISS_ERROR = 'HOME_GET_CUSTOMERS_DISMISS_ERROR';
export const HOME_GET_LOGIN_TIMES_BEGIN = 'HOME_GET_LOGIN_TIMES_BEGIN';
export const HOME_GET_LOGIN_TIMES_SUCCESS = 'HOME_GET_LOGIN_TIMES_SUCCESS';
export const HOME_GET_LOGIN_TIMES_FAILURE = 'HOME_GET_LOGIN_TIMES_FAILURE';
export const HOME_GET_LOGIN_TIMES_DISMISS_ERROR = 'HOME_GET_LOGIN_TIMES_DISMISS_ERROR';
export const HOME_GET_EXERCISE_STATISTICS_BEGIN = 'HOME_GET_EXERCISE_STATISTICS_BEGIN';
export const HOME_GET_EXERCISE_STATISTICS_SUCCESS = 'HOME_GET_EXERCISE_STATISTICS_SUCCESS';
export const HOME_GET_EXERCISE_STATISTICS_FAILURE = 'HOME_GET_EXERCISE_STATISTICS_FAILURE';
export const HOME_GET_EXERCISE_STATISTICS_DISMISS_ERROR = 'HOME_GET_EXERCISE_STATISTICS_DISMISS_ERROR';
export const HOME_DO_BOOTSTRAPING = 'HOME_DO_BOOTSTRAPING';



// WEBPACK FOOTER //
// ./src/features/home/redux/constants.js